"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.args = exports.arg = void 0;
exports.arg = {
    $grammar: {
        "arg:plain": [{ arg: "exp" }],
        "arg:implicit": ['"implicit"', { arg: "exp" }],
    },
};
exports.args = {
    $grammar: {
        "args:args": [
            { entries: { $ap: ["zero_or_more", "arg", '","'] } },
            { last_entry: "arg" },
            { $ap: ["optional", '","'] },
        ],
    },
};
//# sourceMappingURL=arg.js.map